/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2020/3/16
 * Time: 15:28
 * Desc: 直播管理
 */

import { Component, Vue } from 'vue-property-decorator';
import type { ElTree } from 'element-ui/types/tree';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import GoodsLink from '@/views/components/goodsLink/goodsLink.vue';
import { appEnvConfig } from '@/configs/appConfigs';
import GenerateLink from '@/views/components/generateLink';
import { desensitize, noop, parseSec } from '@/util';
import ExportFile from '@/views/components/exportFile';
import NewSelectSite from '@/views/components/newSelectSIte';

@Component({
  components: {
    NoAuth,
    GoodsLink,
    ExportFile,
  },
})
export default class VideoManage extends Vue {
  /* 数据 */

  /**
   * loading状态
   * @type {boolean}
   */
  public isLoadingShow = false;

  /**
   * 商品列表
   * @type {Array<GoodsList>}
   */
  public goodsList: Array<GoodsList> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 是否选中活动
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 直播列表
   * @type {any[]}
   */
  public videoList: Array<LiveViewList> = [];

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = true;

  /**
   * 排序类型
   * @type {number}
   * @desc
   * 0:默认创建倒序
   * 1:开播网点正序
   * 2:开播网点倒叙
   * 3:关联商品正序
   * 4:关联商品倒叙
   * 5:观看量正序
   * 6:观看量倒序
   * 7:分享数正序
   * 8:分享数倒序
   * 9:销量正序
   * 10:销量倒序
   * 11:更新时间正序
   * 12:更新时间倒序
   */
  public sort = 0;

  /**
   * 选中的直播列表
   */
  public selectedVideoList: Array<LiveViewList> = [];

  /**
   * 直播状态列表
   * @type { Array<ItemObject> }
   */
  public videoStateList: Array<ItemObject> = [
    { value: 0, label: '全部' },
    { value: 1, label: '未开始' },
    { value: 2, label: '直播中' },
    { value: 3, label: '直播结束' },
    { value: 4, label: '活动过期' },
    { value: 5, label: '已下架' },
    { value: 6, label: '暂存' },
  ];

  /**
   * 直播列表状态
   * @type {number}
   */
  public videoState: any = null;

  /**
   * 网点销售量弹窗是否显示
   * @type {boolean}
   */
  public isSiteSalePopShow = false;

  /**
   * 网点树列表
   * @type {any[]}
   */
  public siteTreeList: Array<ItemObject> = [];

  /**
   * 树的默认配置
   * @type {{children: string; label: string}}
   */
  public defaultProps: ItemObject = {
    children: 'children',
    label: 'name',
  };

  /**
   * 网点销量列表
   * @type {any[]}
   */
  public siteSaleList: Array<SiteSaleList> = [];

  /**
   * 销量网点列表
   * @type {any[]}
   */
  public saleSiteList: Array<SaleSiteList> = [];

  /**
   * 直播销售店铺列表是否显示
   * @type {boolean}
   */
  public isSaleSiteListShow = true;

  /**
   * 直播销售店铺列表参数
   * @type {{}}
   */
  public saleSiteObj: ListParam = {
    keywords: '',
    page: 1,
    pageSize: 10,
    sort: 0,
    totalCount: 0,
  };

  /**
   * 当前选中的直播
   * @type {LiveViewList}
   */
  public curVideoItem: ItemObject = {};

  /**
   * 当前选中的网点列表
   * @type {any[]}
   */
  public siteCodesList: Array<string> = [];

  /**
   * 当前选中的网点Id
   * @type {string}
   */
  public curSiteCode = '';

  /**
   * 当前选中的网点名称
   * @type {string}
   */
  public curSiteName = '';

  /**
   * 商品连接生成工具弹窗是否显示
   * @type {string}
   */
  public isGoodsLinkPopShow = false;

  /**
   * 管理员ID
   * @type {string}
   */
  public empCode = '';

  /**
   * 导出状态
   * @type {number}
   */
  public exportBtnInfo = [{ state: 0, url: '' }];

  /**
   * socket状态
   * @type {boolean}
   */
  public isSocketReady = false;

  /**
   * sendToId
   * @type {Array<ItemObject>}
   */
  public sendToIdList = [`${appEnvConfig.NODE_ENV}VideoExport${this.$store.state.empCode}`];

  public date = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;
  /* 方法 */

  public dateChange() {
    this.page = 1;
    this.getVideoList();
  }

  /**
   * 直播列表导出
   * @returns null
   */
  get exportParams() {
    const postParams = {
      exportType: 'liveView',
      params: {
        keywords: this.keywords,
        status: +this.videoState,
        sort: this.sort,
      },
    };
    if (this.date && this.date.length) {
      (postParams.params['startOfTime'] = parseSec(1, this.date[0])), (postParams.params['endOfTime'] = parseSec(2, this.date[1]));
    }
    return postParams;
  }

  /**
   * 关键字搜索
   * @returns null
   */
  public onSearchVideo(): void {
    this.page = 1;
    this.pageSize = 10;
    this.sort = 0;
    this.getVideoList(); // 获取直播管理列表
  }

  /**
   * 获取直播管理列表
   * @returns null
   */
  public getVideoList(): void {
    this.isLoadingShow = true;
    const postParams = {
      page: this.page,
      pageNum: this.pageSize,
      keywords: this.keywords.trim(),
      status: this.videoState,
      sort: this.sort,
    };
    if (this.date && this.date.length) {
      (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('更新时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
        this.ipsGetList(postParams);
        return;
      }
    }
    this.ipsGetList(postParams);
  }

  ipsGetList(postParams) {
    IPSService.liveViewList({ postParams })
      .then((res) => {
        this.videoList = [];
        // 格式化数据
        if (res.list.length > 0) {
          res.list.forEach((item) => {
            item.actBeginTime = Functions.emptyVaribleHandler(item.actBeginTime);
            item.actEndTime = Functions.emptyVaribleHandler(item.actEndTime);
            item.lvBeginTime = Functions.emptyVaribleHandler(item.lvBeginTime);
            item.lvEndTime = Functions.emptyVaribleHandler(item.lvEndTime);
            item.lvName = Functions.emptyVaribleHandler(item.lvName);
            item.shareNum = item.shareNum || 0;
            item.viewNum = item.viewNum || 0;
            item.sgName = Functions.emptyVaribleHandler(item.sgName);
            item.createPerson = Functions.emptyVaribleHandler(item.createPerson);
            item.updateTime = Functions.emptyVaribleHandler(item.updateTime);
          });
        }
        this.videoList = res.list;
        this.totalCount = res.count;
        this.isLoadingShow = false;
      })
      .catch(() => {
        this.isLoadingShow = false;
      });
  }

  /**
   * 获取直播状态
   * @param { number } status
   * @returns { string }
   */
  public getVideoState(status: number): string {
    let label = '未开始';
    this.videoStateList.forEach((item) => {
      if (item.value === status) {
        label = item.label;
      }
    });
    return label;
  }

  /**
   * 列表选中
   * @returns null
   */
  public handleSelectionChange(val: Array<any>): void {
    this.selectedVideoList = val;
  }

  /**
   * 列表排序
   * @param { ItemObject } column
   * @returns null
   */
  public onSortChange(column: ItemObject): void {
    let sort = 0;
    const isAscending = column.order === 'ascending';
    switch (column.prop) {
      case 'siteNum': // 开播网点
        sort = isAscending ? 1 : 2;
        break;
      case 'productNum': // 关联商品
        sort = isAscending ? 3 : 4;
        break;
      case 'viewNum': // 观看量
        sort = isAscending ? 5 : 6;
        break;
      case 'shareNum': // 分享数
        sort = isAscending ? 7 : 8;
        break;
      case 'orderNum': // 销量
        sort = isAscending ? 9 : 10;
        break;
      case 'updateTime': // 更新时间
        sort = isAscending ? 11 : 12;
        break;
      default:
        sort = 0;
        break;
    }
    this.sort = sort;
    this.getVideoList(); // 获取直播管理列表
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getVideoList();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getVideoList();
  }

  /**
   * 新建/编辑/查看直播
   * @param { number } id
   * @param { number } type // 0 : 可编辑 1: 不可编辑
   * @returns null
   */
  public onEditVideo(id: number, type: number): void {
    this.$router.push(`/videoManage/${id}/${type}`);
  }

  /**
   * 更改直播状态
   * @param { ItemObject } item
   * @param { number } val 状态 -1删除 0暂存 1上架 2下架 (只会调用删除/上架/下架)
   * @returns null
   */
  public onChangeVideoState(item: ItemObject, val: number): void {
    let txt = '';
    if (val === -1) {
      txt = '删除';
    } else if (val === 0) {
      txt = '暂存';
    } else if (val === 1) {
      txt = '上架';
    } else if (val === 2) {
      txt = '下架';
    } else {
      return;
    }

    this.$confirm(`确定要对【${item.lvName}】进行${txt}操作？`, '提示')
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: '请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(225,225,225,0.3)',
        });
        const postParams = {
          lvId: item.lvId,
          state: val,
        };
        IPSService.liveViewStateSave({ postParams })
          .then((res) => {
            loading.close();
            if (res) {
              this.$message.success(`${txt}成功！`);
              this.page = 1;
              this.pageSize = 10;
              this.sort = 0;
              this.getVideoList(); // 获取直播列表
            } else {
              this.$message.error(`${txt}失败！`);
            }
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch(() => {
        return false;
      });
  }

  // 直播活动链接
  public onLink(item) {
    GenerateLink.open({
      item,
      title: '生成直播活动链接',
      type: 'live',
      confirm: false,
      // remarkList: ["注1：默认生成的链接为适用网点列表第一个网点的链接，可通过输入网点编号后进行更换；"],
    }).then(noop, noop);
  }

  /**
   * 网点销售量弹窗显示
   * @param { number } type
   * @param { LiveViewList } item
   * @returns null
   */
  public onSiteListShow(item: ItemObject): void {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: item.siteList,
      readonly: true,
    }).then(noop, noop);
  }
  siteCodes=[]
  openSelectSiteDialog() {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: this.siteCodes,
      readonly: false,
    }).then((val: string[]) => {
      this.siteCodesList = val;
      this.getSiteSaleLists();
    }, noop);
  }

  public onSiteSalePopShow(item: LiveViewList, type: number): void {
    this.isSiteSalePopShow = true;
    this.siteCodes=item.siteList
    this.isSaleSiteListShow = type === 1;
    this.curVideoItem = item;
    // this.getSiteTreeList(item); // 获取权限下网点树信息
  }

  /**
   * 网点销售量弹窗隐藏
   * @returns null
   */
  public onSiteSalePopHide(): void {
    this.isSiteSalePopShow = false;
    this.isSaleSiteListShow=true
    this.saleSiteObj = {
      keywords: '',
      page: 1,
      pageSize: 10,
      sort: 0,
      totalCount: 0,
    };
    this.saleSiteList = [];
    this.siteSaleList = [];
    this.curSiteName = '';
    this.curSiteCode = '';
    this.curVideoItem = {};
  }

  /**
   * 导出网点销售列表
   * @returns null
   */
  public onExportSiteSaleList(): void {
    if (this.isSaleSiteListShow) {
      Functions.excelMaker({
        columns: [
          { header: '网点编号', key: 'siteCode', width: 10 },
          { header: '网点名称', key: 'siteName', width: 20 },
          { header: '销售商品量', key: 'productNum', width: 20 },
          { header: '销售金额', key: 'orderPrice', width: 20 },
        ],
        data: this.saleSiteList,
        name: `${this.curSiteName}的销售网点`,
      });
    } else {
          // 1正常 2半脱敏 3全脱敏
    const secureLevel = +localStorage.getItem('secureLevel')
      if ((secureLevel === 2 || secureLevel === 3)) {
        this.siteSaleList.map((i: any) => {
          i.buyerName = desensitize(i.buyerName, 'name')||''
          i.buyerTel = desensitize(i.buyerTel, 'phone')||''
          return i;
        })
      }

      Functions.excelMaker({
        columns: [
          { header: '订单编号', key: 'orderSn', width: 10 },
          { header: '购买人', key: 'buyerName', width: 20 },
          { header: '手机号', key: 'buyerTel', width: 20 },
          { header: '商品名称', key: 'productName', width: 20 },
          { header: '商品数量', key: 'productNum', width: 20 },
          { header: '支付金额', key: 'payPrice', width: 20 },
          { header: '下单时间', key: 'orderTime', width: 20 },
          { header: '支付时间', key: 'payTime', width: 20 },
        ],
        data: this.siteSaleList,
        name: `${this.curSiteName}的网点销售`,
      });
      console.log(this.siteSaleList)
    }
  }

  /**
   * 获取网店销售/销售网点列表
   * @returns null
   */
  public getSiteSaleLists(): void {
    if (this.isSaleSiteListShow) {
      this.getSaleSiteList(); // 获取直播销售网点
    } else {
      this.getSiteSaleList(); // 获取直播网点销售
    }
  }

  /**
   * 获取区域网点列表
   * @returns null
   */
  // public getSiteTreeList(item: LiveViewList): void {
  //   this.isLoadingShow = true;
  //   const postParams = {
  //     siteCodes: item.siteList || [],
  //   };
  //   IPSService.getAdminAuthTree({ postParams })
  //     .then((res) => {
  //       if (res.treeList) {
  //         this.siteTreeList = res.treeList;
  //         this.curSiteName = res.treeList[0].name;
  //         this.siteCodesList = item.siteList;
  //         this.getSiteSaleLists(); // 获取网店销售/销售网点列表
  //         this.setCurrentkey(res.treeList[0].code);
  //       }
  //     })
  //     .catch(() => {
  //       this.isLoadingShow = false;
  //     });
  // }

  /**
   * 关键字搜索直播销售店铺
   * @returns null
   */
  public onSearchSaleSiteList(): void {
    this.saleSiteObj = {
      keywords: this.saleSiteObj.keywords,
      page: 1,
      pageSize: 10,
      sort: 0,
      totalCount: 0,
    };
    this.getSiteSaleLists(); // 获取网店销售/销售网点列表
  }

  /**
   * 销售网点条数变更
   * @param { number } val
   * @returns null
   */
  public onSaleSiteSizeChange(val: number): void {
    this.saleSiteObj.pageSize = val;
    this.getSiteSaleLists(); // 获取网店销售/销售网点列表
  }

  /**
   * 销售网点页码变更
   * @param { number } val
   * @returns null
   */
  public onSaleSitePageChange(val: number): void {
    this.saleSiteObj.page = val;
    this.getSiteSaleLists(); // 获取网店销售/销售网点列表
  }

  /**
   * 销售网点排序变更
   * @param { ItemObject } column
   * @returns null
   */
  public onSaleSiteSortChange(column: ItemObject): void {
    let sort = 0;
    const isAscending = column.order === 'ascending';
    switch (column.prop) {
      case 'productNum': // 销售商品量
        sort = isAscending ? 1 : 3;
        break;
      case 'orderPrice': // 销售金额
        sort = isAscending ? 4 : 5;
        break;
      default:
        sort = 0;
        break;
    }
    this.saleSiteObj.sort = sort;
    this.getSaleSiteList(); // 获取直播销售店铺列表
  }

  /**
   * 获取直播销售店铺列表
   * @returns null
   */
  public getSaleSiteList(): void {
    this.isLoadingShow = true;
    const postParams = {
      lvId: this.curVideoItem.lvId,
      keywords: this.saleSiteObj.keywords.trim(),
      siteCodes: this.siteCodesList.join() || '',
      page: this.saleSiteObj.page,
      pageNum: this.saleSiteObj.pageSize,
      sort: this.saleSiteObj.sort,
    };
    IPSService.liveViewSiteList({ postParams })
      .then((res) => {
        this.isLoadingShow = false;
        this.saleSiteList = [];
        this.saleSiteObj.totalCount = res.count;
        if (res.list.length > 0) {
          res.list.forEach((sItem) => {
            sItem.siteCode = Functions.emptyVaribleHandler(sItem.siteCode);
            sItem.siteName = Functions.emptyVaribleHandler(sItem.siteName);
          });
        }
        this.saleSiteList = res.list;
      })
      .catch(() => {
        this.isLoadingShow = false;
      });
  }

  /**
   * 查看销售店铺详情
   * @param { SaleSiteList } item
   * @returns null
   */
  public onSaleSiteDetailShow(item: SaleSiteList): void {
    this.saleSiteObj = {
      keywords: '',
      page: 1,
      pageSize: 10,
      sort: 0,
      totalCount: 0,
    };
    this.isSaleSiteListShow = false;
    this.curSiteCode = item.siteCode;
    this.getSiteSaleList(); // 获取直播网点销售
    this.setCurrentkey(item.siteCode);
  }

  /**
   * 获取直播店铺销售列表
   * @returns null
   */
  public getSiteSaleList(): void {
    this.isLoadingShow = true;
    const postParams = {
      lvId: this.curVideoItem.lvId,
      siteCode: this.curSiteCode || '',
      keywords: this.saleSiteObj.keywords.trim(),
      page: this.saleSiteObj.page,
      pageNum: this.saleSiteObj.pageSize,
    };
    IPSService.liveViewSaleList({ postParams })
      .then((res: any) => {
        this.isLoadingShow = false;
        this.siteSaleList = [];
        this.saleSiteObj.totalCount = res.count;
        if (res.list.length > 0) {
          res.list.forEach((item) => {
            item.orderSn = Functions.emptyVaribleHandler(item.orderSn);
            item.productName = Functions.emptyVaribleHandler(item.productName);
            item.orderTime = Functions.timeFormat(item.orderTime);
            item.payTime = Functions.timeFormat(item.payTime);
          });
        }
        this.siteSaleList = res.list;
      })
      .catch(() => {
        this.isLoadingShow = false;
      });
  }

  /**
   * 点击树节点
   * @param { ItemObject } val
   * @returns null
   */
  // public onHandleNodeClick(val: ItemObject): void {
  //   this.curSiteName = val.name;
  //   this.saleSiteObj = {
  //     keywords: '',
  //     page: 1,
  //     pageSize: 10,
  //     sort: 0,
  //     totalCount: 0,
  //   };
  //   this.isSaleSiteListShow = val.hasOwnProperty('children');
  //   let temList = [];
  //   if (this.isSaleSiteListShow) {
  //     const getSiteCodes = (item: any) => {
  //       if (item.hasOwnProperty('children')) {
  //         item.children.forEach((sItem) => {
  //           if (sItem.hasOwnProperty('children')) {
  //             getSiteCodes(sItem);
  //           } else {
  //             temList.push(sItem.code);
  //           }
  //         });
  //       }
  //     };
  //     getSiteCodes(val);
  //     this.siteCodesList = temList;
  //     this.getSaleSiteList(); // 获取直播销售网点
  //   } else {
  //     this.curSiteCode = val.code;
  //     this.getSiteSaleList(); // 获取直播网点销售
  //   }
  //   temList = null;
  // }

  /**
   * 设置节点选中状态
   * @param {string} val
   * @returns null
   */
  public setCurrentkey(val: string): void {
    this.$nextTick(() => {
      (this.$refs.siteTree as ElTree<any, any>).setCurrentKey(val);
    });
  }

  /**
   * 同步商品信息弹窗显示
   * @returns null
   */
  public onGoodsLinkPopShow(): void {
    this.isGoodsLinkPopShow = true;
  }

  /**
   * 商品连接生成工具弹窗显示
   * @returns null
   */
  public onGoodsLinkPopHide(): void {
    this.isGoodsLinkPopShow = false;
    // @ts-expect-error
    this.$refs.goodsLink.clearData();
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-LIVE-VIEW');
    if (this.isContentBodyShow) {
      this.defaultStart = parseSec(3);
      this.defaultEnd = parseSec(4);
      this.date = [this.defaultStart, this.defaultEnd];
      this.getVideoList(); // 获取直播管理列表
    }
    this.empCode = localStorage.getItem('empCode') || '';
  }
}
